import React from "react";
import styled from "styled-components";

const AdminTitle = ({ children, kanji = "管理" }) => (
  <Title>
    {children} <span>{kanji}</span>
  </Title>
);

export default AdminTitle;

const Title = styled.h1`
  font-family: "Anton", sans-serif;
  font-weight: 400;
  text-transform: uppercase;
  font-size: 3rem;
  line-height: 1;
  letter-spacing: 0.02em;
  color: var(--text, #f4f2ee);
  margin-bottom: 1rem;

  span {
    font-family: var(--font-kanji);
    font-size: 0.6em;
    color: var(--red, #fe5f55);
    vertical-align: middle;
    margin-left: 0.6rem;
  }
`;
